import '../assets/styles/ServiceCard.css';

export default function ServiceCard({ title, description, image }) {
  return (
    <div className="service-card">
      <div className="service-card-image">
        <img src={image} alt={title} />
      </div>
      <div className="service-card-content">
        <h3>{title}</h3>
        <p>{description}</p>
      </div>
    </div>
  );
}